module.exports = __webpack_public_path__ + "img/waiter.a377f29c.png";